import PageHome from "./index";

export default PageHome;
